import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowPickersLayout: Components<Theme>['MuiPickersLayout'] = {
  styleOverrides: {
    root: {
      '&:has(.MuiPickersLayout-shortcuts)': {
        // extra space
        paddingTop: '16px',
        // has action bar with content
        '&:not(&:has(.MuiPickersLayout-actionBar > *))': {
          paddingBottom: '16px',
          '& .MuiPickersLayout-shortcuts': {
            '&:after': {
              bottom: '0',
            },
          },
        },
        // move into actionBar
        '& .MuiPickersLayout-shortcuts': {
          gridRow: '1/4',
          '&:after': {
            top: '0',
          },
        },
        '& .MuiPickersLayout-actionBar': {
          gridColumn: '2/4',
        },
      },
    },
  },
};
